module.exports = __webpack_public_path__ + "media/images/area/icon_weather_20-08ee29abacd5ee3f23e69e9a9e29237e.png";